import type { FaireProductEntity } from "../../entity_types/product";

export const p_eskzehpg: FaireProductEntity = {
  token: "p_eskzehpg",
  type: "product",
  name: "Mason Jar Wood Wick Soy Candle Home Decor Gift Holiday",
  brandName: "Woodfire Candle Company",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/a1adf2c92407dad552d17bc352507bd6946a233f3f967c2346a4c5ca27c9e033/1528248108.jpg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/4eff0ce370003df5d1d80ee761fed350b005bc31852d761b7c5913d14e411f58.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
